export function findNodeById(page, nodeId) {
  let level = null;

  if (nodeId.startsWith("con-")) level = "container";
  else if (nodeId.startsWith("crd-")) level = "card";
  else if (nodeId.startsWith("el-")) level = "element";
  else level = "section";

  for (let s = 0; s < page.sections.length; s++) {
    const section = page.sections[s];

    if (level === "section" && section.id === nodeId) {
      return {
        node: section,
        level,
        path: { sectionIndex: s }
      };
    }

    // Containers
    for (let c = 0; c < section.contents.length; c++) {
      const container = section.contents[c];

      if (level === "container" && container.id === nodeId) {
        return {
          node: container,
          level,
          path: { sectionIndex: s, containerIndex: c }
        };
      }

      // Cards
      for (let cd = 0; cd < container.cards.length; cd++) {
        const card = container.cards[cd];

        if (level === "card" && card.id === nodeId) {
          return {
            node: card,
            level,
            path: { sectionIndex: s, containerIndex: c, cardIndex: cd }
          };
        }

        // Elements
        for (let e = 0; e < card.elements.length; e++) {
          const element = card.elements[e];

          if (element.id === nodeId) {
            return {
              node: element,
              level: "element",
              path: {
                sectionIndex: s,
                containerIndex: c,
                cardIndex: cd,
                elementIndex: e
              }
            };
          }
        }
      }
    }
  }

  return null; // not found
}


export function getParentPath(page, nodeId) {
  const result = findNodeById(page, nodeId);
  if (!result) return null;

  const { level, path } = result;

  switch (level) {
    case "container":
      return { ...path, parentLevel: "section" };
    case "card":
      return { ...path, parentLevel: "container" };
    case "element":
      return { ...path, parentLevel: "card" };
    case "section":
    default:
      return null;
  }
}


// export function updateNode(page, nodeId, updates) {
//   const result = findNodeById(page, nodeId);
//   if (!result) return page;

//   const { level, path } = result;

//   const newPage = JSON.parse(JSON.stringify(page)); // IMMUTABLE DEEP COPY

//   const sec = newPage.sections[path.sectionIndex];

//   if (level === "section") {
//     Object.assign(sec, updates);
//   } else if (level === "container") {
//     Object.assign(sec.contents[path.containerIndex], updates);
//   } else if (level === "card") {
//     Object.assign(sec.contents[path.containerIndex].cards[path.cardIndex], updates);
//   } else if (level === "element") {
//     Object.assign(
//       sec.contents[path.containerIndex].cards[path.cardIndex].elements[path.elementIndex],
//       updates
//     );
//   }

//   return newPage;
// }

export function updateNode(page, nodeId, updatedNode) {
  const newPage = JSON.parse(JSON.stringify(page));

  for (const sec of newPage.sections) {
    if (sec.id === nodeId) {
      Object.assign(sec, updatedNode);
      return newPage;
    }

    for (const con of sec.contents) {
      if (con.id === nodeId) {
        Object.assign(con, updatedNode);
        return newPage;
      }

      for (const card of con.cards) {
        if (card.id === nodeId) {
          Object.assign(card, updatedNode);
          return newPage;
        }

        const elIndex = card.elements.findIndex(el => el.id === nodeId);
        if (elIndex !== -1) {
          card.elements[elIndex] = { ...card.elements[elIndex], ...updatedNode };
          return newPage;
        }
      }
    }
  }

  return page;
}

function getNodeType(nodeId) {
  if (nodeId.startsWith("con-")) return "container";
  if (nodeId.startsWith("crd-")) return "card";
  if (nodeId.startsWith("el-")) return "element";
  return "section"; // default
}